jq2 = jQuery.noConflict();
jq2(function ($) {

    // $('.product-thumbs-slider').slick({
    //     infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 3,
    // });
    $(document).on('change', 'select.country-select', function () {
        var country = $(this).val();
        var cities = vars.cities[country];
        console.log(cities);
        var html = '<option value>--</option>';
        $.each(cities, function (id, city) {
            html += '<option value="' + city.id + '">' + city.name + '</option>';
        });

        $('select.city-select').html(html);
    });

    $('.collapse').on('shown.bs.collapse', function () {
        $(this).parent().find(".glyphicon-chevron-down").removeClass("glyphicon-chevron-down").addClass("glyphicon-chevron-up");
    }).on('hidden.bs.collapse', function () {
        $(this).parent().find(".glyphicon-chevron-up").removeClass("glyphicon-chevron-up").addClass("glyphicon-chevron-down");
    });

    $(document).on('focus', '.datepicker', function() {
        $(this).datepicker({
            format: 'yyyy',
            language: 'lt',
            minViewMode: 'years',
            autoclose:true
        });
    });

    $('.datepicker').datepicker({
        format: 'yyyy',
        language: 'lt',
        minViewMode: 'years',
        autoclose:true
    });

    $('.datepicker').datepicker({
        format: 'yyyy',
        language: 'lt',
        minViewMode: 'years',
        autoclose:true
    });
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('#order').on('change', function () {
        orderChange('order', $(this).val());
    });

    $('#perpage').on('change', function () {
        perPageChange('perpage', $(this).val());
    });

    var searchParams;
    if(URI.parse(window.location.href).query) {
        searchParams = URI.parseQuery('?'+window.location.href.substring(window.location.href.indexOf('?') + 1, window.location.href.length));
    } else {
        searchParams = [];
    }

    $(document).on('change', 'input.priceValue', function() {
        var min = $("#priceMin").val();
        var max = $("#priceMax").val();
        sliderChange('price', [min,max]);
    });

    $("input.yearValue").change(function() {
        var min = $("#yearMin").val();
        var max = $("#yearMax").val();
        sliderChange('year', [min, max]);
    });

    $("select#make_id").change(function() {
        perPageChange('make_id', $(this).val());
    });

    $('input.number-Filter').change(function() {
        var inputs = $(this).parent('div').parent('div').find("input");
        console.log(inputs);
        var min = parseInt($(inputs).first().val());
        var max = parseInt($(inputs).last().val());
        if(max <= min) {
            max += 1000;
            $(inputs).last().val(max);
        }
        sliderChange($(inputs).attr('name'), [min, max]);
    });

    function sliderChange(name, values) {
        searchParams[name] = values[0]+','+values[1];
        completeSearch();
    }

    function orderChange(name, values) {
        searchParams[name] = values;
        completeSearch();
    }

    function perPageChange(name, values){

        if(values.length === 0){
            delete searchParams[name];
        } else {
            searchParams[name] = values;
        }
        completeSearch();
    }

    function checkboxChange(name, value) {
        if(searchParams[name]) {
            var params = searchParams[name].split(',');
            console.log(params.indexOf(value));
            if(params.indexOf(value) > -1 ) {
                params.splice(params.indexOf(value), 1);
            } else {
                params.push(value);
            }
            if(params.length > 0){
                searchParams[name] = params.join(',');
            }
            else {
                delete searchParams[name];
            }
        } else {
            searchParams[name] = value;
        }
        completeSearch();

    }
    function completeSearch() {

        var uri = new URI();
        searchParams['page'] = 1;
        uri.search(searchParams);
        //window.location = uri.href();
        console.log(uri);
        $.ajax({
            type: "GET",
            url: uri.href(),
            success: function (response) {
                console.log(response);
                response = JSON.parse(response);
                $('#resultCount').text(response['total']);
                $('div.results-list').html(response['html']);
                // console.log(response['total'] + ' '+vars.no_results);
                // if(response['total'] == 0){
                //     $('#category_name').text(vars.no_results);
                // }
            },
            error: function (data) {
                console.log('Error: ' + JSON.stringify(data));
            }
        });
        window.history.pushState({},null,uri.href());
    }

    // select checboxes
    $('input.checkboxFilter').on('change',function() {
        var name = $(this).attr('name');
        checkboxChange(name, $(this).val());
    });

    $('.advert__results--clear').on('click', function () {

        var form =$(this).parent()[0];
        $.each($(form).find('input'), function(index, val){
           console.log($(val).attr('name'));
            delete searchParams[$(val).attr('name')];
        });

        $.each($(form).find('select'), function(index, val){
            console.log($(val).attr('name'));
            delete searchParams[$(val).attr('name')];
        });
        // $(form).reset();
        var uri = new URI();
        searchParams['page'] = 1;
        uri.search(searchParams);
        window.location = uri.href();
        // completeSearch();
    });

    function getSelectValues(select) {
        var result = [];
        var options = select && select.options;
        var opt;

        for (var i=0, iLen=options.length; i<iLen; i++) {
            opt = options[i];

            if (opt.selected) {
                result.push(opt.value || opt.text);
            }
        }
        return result.join();

    }

    // $(document).on('change', '.checkboxFilter', function() {
    //     var name = $(this).attr('name');
    //     checkboxChange(name, $(this).val());
    // });
//------------------------------------------------------------------------------------


    $('.collapse').on('shown.bs.collapse', function () {
        $(this).parent().find(".glyphicon-chevron-down").removeClass("glyphicon-chevron-down").addClass("glyphicon-chevron-up");
    }).on('hidden.bs.collapse', function () {
        $(this).parent().find(".glyphicon-chevron-up").removeClass("glyphicon-chevron-up").addClass("glyphicon-chevron-down");
    });

    $(document).on('focus', '.datepicker', function() {
        $(this).datepicker({
            format: 'yyyy',
            language: 'lt',
            minViewMode: 'years',
            autoclose:true
        });
    });

    $('.datepicker').datepicker({
        format: 'yyyy',
        language: 'lt',
        minViewMode: 'years',
        autoclose:true
    });
    var uri = URI();
    var ctgs = [];
    if(uri.hasQuery("categories") === true)
    {
        ctgs = uri.search(true).categories.split(',');
    }
    $(document).on('change', '#subsubcategory_id2', function () {
        var makeid = $('#subsubcategory_id2 option[value="' + $(this).val() + '"]').attr('data-make-id');
        if ($(this).val() > 0)
            getPropertiesSearch($('#subsubcategory_id2').val());
        else {
            if ($('#subcategory_id2').val() > 0)
                getPropertiesSearch($('#subcategory_id2').val());
            else {
                if ($('#category_id2').val() > 0) {
                    getPropertiesSearch($('#category_id2').val());
                } else {
                    $('.details').html('');
                    $('.specs').html('');
                }
            }
        }
    });
    $(document).on('change', '#subcategory_id2', function () {
        //getProperties($('#subcategory_id').val());

        var subcatid = $(this).val();
        var html = '';
        if (subcatid != 0 && Object.keys(categories[' '+$("select#category_id2").val()]['children'][' '+subcatid]['children']).length > 0) {
            $.each(categories[' '+$("select#category_id2").val()]['children'][' '+subcatid]['children'], function (index, value) {
                var selcted = '';
                if(ctgs[2] == index.trim())
                {
                    selcted = 'selected="selected"';
                }
                html += '<option value="' + index.trim() + '"'+selcted+'>' + value.name + '</option >';
            });
        } else
            html += '   <option value="0">Pasirinkite sub subkategoriją</option >';
        $('#subsubcategory_id2').html(html);
        $('#subsubcategory_id2').trigger('change');

    });
    $("select#category_id2").on('change', function () {
        var catid = $(this).val();
        var html = '';

        if (catid != 0 && Object.keys(categories[' ' + catid]['children']).length > 0) {
            $.each(categories[' '+catid]['children'], function (index, value) {
                var selcted = '';
                if(ctgs[1] == index.trim())
                {
                    selcted = 'selected="selected"';
                }
                html += '<option value="' + index.trim() + '"'+selcted+'>' + value.name + '</option >';
            });
        } else
            html += '   <option value="0">Pasirinkite subkategoriją</option >';

        $('#subcategory_id2').html(html);
        $('#subcategory_id2').trigger('change');
    });


    $("select[name='yearFrom']").on('change', function () {
        var selected = $("select[name='yearFrom']").val();
        $("select[name='yearTo'] option").each(function( index, value ) {
            $(this).removeAttr('disabled');
            if(value >= $(this).val()){
                $(this).attr('disabled="disabled"');
            } else {
                return false;
            }
        });
    });

    $.fn.jsonSerialize = function() {
        var json = {};
        var array = $(this).serializeArray();
        $.each(array, function(key, obj) {
            var value = (obj.value == "") ? false : obj.value;
            if(value) {
                // check if we have a number
                var isNum = /^\d+$/.test(value);
                if(isNum) value = parseFloat(value);
                // check if we have a boolean
                var isBool = /^(false|true)+$/.test(value);
                if(isBool) value = (value!=="false");
            }
            json[obj.name] = value;
        });
        return json;
    };

    $('#indexSearch').on('submit', function(e) {
        e.preventDefault();
        var values = $(this).serialize();
        var params = URI.parseQuery('?'+values);
        if(params['year[]']) {
            if(params['year[]'][0] != '0' || params['year[]'][1] != '0')
                params['year'] = params['year[]'][0]+','+params['year[]'][1];
        }
        if(params['category_id[]']) {
            if(params['category_id[]'][1] != '' && params['category_id[]'][1] != '0')
                params['category_id'] = params['category_id[]'][1];
            else if(params['category_id[]'][0] != 0)
                params['category_id'] = params['category_id[]'][0];

            delete params['category_id[]'];
        }
        if(params['make_id'].length < 1 ) {
            delete params['make_id'];
        }
        if(params['country_id'] == 0 ) {
            delete params['country_id'];
        }
        if(params['price[]']) {
            var min,max = 0;
            if((params['price[]'][0] != 0 ) || (params['price[]'][1] != 0 && params['price[]'][1] != '')) {
                if(params['price[]'][0] == '')
                    min = 0;
                else
                    min = params['price[]'][0];
                if(params['price[]'][1] == '')
                    max = 0;
                else max = params['price[]'][1];
                params['price'] = min+','+max;
            }
        }

        var uri = new URI($(this).attr('action'));
        uri.setSearch(params);
        uri.removeSearch('year[]');
        uri.removeSearch('price[]');
        uri.removeSearch('category_id[]');
        window.location = uri.href();
    });

    // $("select#category_id").on('change', function () {
    //     var catid = $(this).val();
    //     var html = '';
    //     html += '   <option value="0">Pasirinkite</option >';
    //     if(catid != 0) {
    //         $.each(categories[' '+catid]['children'], function (index, value) {
    //             html += '<option value="' + index.trim() + '">' + value.name + '</option >';
    //         });
    //     }
    //     $('#subcategory_id').html(html);
    //     if ($('.specs').length == 0) {
    //         getMakes($(this).val());
    //     }
    // });

    // $("select#subcategory_id").on('change', function () {
    //     var subcatid = $(this).val();
    //     var html = '';
    //     html += '   <option value="0">Pasirinkite</option >';
    //     if(subcatid != 0) {
    //         $.each(categories[' '+$("select#category_id").val()]['children'][' '+subcatid]['children'], function (index, value) {
    //             html += '<option value="' + index.trim() + '">' + value.name + '</option >';
    //         });
    //     }
    //
    //     $('#subsubcategory_id').html(html);
    //
    //     if ($('.specs').length == 0) {
    //         getMakes($(this).val());
    //     }
    // });

    // $('select#subsubcategory_id').on('change', function() {
    //     if ($('.specs').length == 0) {
    //         getMakes($(this).val());
    //     } else {
    //         var makeid = $('#subsubcategory_id option[value="'+$(this).val()+'"]').attr('data-make-id');
    //         if($(this).val() > 0 )
    //             getPropertiesAdd($('#subsubcategory_id').val());
    //         else {
    //             if ($('#subcategory_id').val() > 0)
    //                 getPropertiesAdd($('#subcategory_id').val());
    //             else {
    //                 if ($('#category_id').val() > 0) {
    //                     getPropertiesAdd($('#category_id').val());
    //                 } else {
    //                     $('.details').html('');
    //                     $('.specs').html('');
    //                 }
    //             }
    //         }
    //     }
    // });

    // function getPropertiesAdd(catid){
    //     $.ajax({
    //         type: "GET",
    //         data: {id:catid},
    //         url: vars.url.getspec,
    //         success: function (msg) {
    //             $('.specs').html(msg);
    //
    //         },
    //         error: function (data) {
    //             // console.log('Error: ' + JSON.stringify(data.status));
    //         }
    //     });
    //
    //     $.ajax({
    //         type: "GET",
    //         data: {id:catid},
    //         url: vars.url.getdetails,
    //         success: function (msg) {
    //             $('.details').html(msg);
    //             if ( $('#type').val() == 2) {
    //
    //                 $('.rent_prices').show();
    //                 $('.details').find('#price_input').closest('.col-sm-4').hide();
    //                 $('.details').find('#price_vat_input').closest('.col-sm-4').hide();
    //             }
    //         },
    //         error: function (data) {
    //             // console.log('Error: ' + JSON.stringify(data.status));
    //         }
    //     });
    // }
    //
    // function getMakes(catid) {
    //     $.ajax({
    //         type: "GET",
    //         data: {id:catid},
    //         url: vars.url.getmakelist,
    //         success: function (msg) {
    //             if(jQuery.isEmptyObject(msg)){
    //                 // console.log('Nera marklių!');
    //             }
    //             var html = '';
    //             html += '   <option value="0">Pasirinkite markę</option >';
    //             $.each(msg, function( index, value ) {
    //                 html += '   <option value="'+value.id+'">'+value.make_name+'</option >';
    //             });
    //             $('#make_id').html(html);
    //         },
    //         error: function (data) {
    //             // console.log('Error: ' + JSON.stringify(data));
    //         }
    //     });
    // }

    $.ajaxSetup({
        headers: {'X-CSRF-TOKEN': $("input[name=_token]").val()}
    });





    function getPropertiesSearch(catid) {
        var url = vars.url.getspec;
        $.ajax({
            type: "GET",
            data: {
                id: catid,
                fromto: true
            },
            url: url,
            success: function (msg) {
                $('.specs').html(msg);
            },
            error: function (data) {
                // console.log('Error: ' + JSON.stringify(data.status));
            }
        });
        var url2 = vars.url.getdetails;
        $.ajax({
            type: "GET",
            data: {
                id: catid,
                fromto: true
                },
            url: url2,
            success: function (msg) {
                $('.details').html(msg);
                if ( $('#type').val() == 2 ) {

                    var template =  $('#price_type_template').clone().removeClass('hidden');
                    $('.details .row').prepend(template);
                }
            },
            error: function (data) {
                // console.log('Error: ' + JSON.stringify(data.status));
            }
        });
    }

    $('#aSearch').on('submit',function(e) {
        e.preventDefault();
        var url = $(this).attr('action');
        //console.log(url);
        var values = $(this).serialize();
        var params = URI.parseQuery('?'+values);
        //console.log(params);

        //if(params['year[]']) {
        //    if(params['year[]'][0] != '0' || params['year[]'][1] != '0')
        //        params['year'] = params['year[]'][0]+','+params['year[]'][1];
        //}
        if(params['make_id'] == '0') {
            delete params['make_id'];
        }
        if(params['country_id'] == 0 || params['country_id'] == '0')
            delete params['country_id'];
        //console.log(params);
        $.each(params, function(key, value) {
           // console.log(key+' '+value);

            if(value == "")
            {
                delete params[key];
            } else {
                if($.isArray(value)) {
                    //console.log('Object: '+key+' => '+JSON.stringify(value));
                    if($.isEmptyObject(value)) {
                        //console.log('tuscias '+value[0]+ ' '+value[1]);
                        delete params[key];
                    }
                    else {
                        //console.log('Netuscias '+value[0]+ ' '+value[1]);
                        if(value[0] != "" || value[1] != "") {
                            if(value[0] == "")
                                value[0] = 0;
                            if(value[1] == "")
                                value[1] = 0;
                            params[key.replace('[]', '')] = value[0] + ',' + value[1];
                        }
                        delete params[key];
                    }
                }
            }
        });
        var uri = new URI($(this).attr('action'));
        uri.setSearch(params);
        //uri.removeSearch('year[]');
        window.location = uri.href();
    });

    //$('select[name="country"]').trigger('change');
  /*  $('.product-thumbs-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3
    });*/
/*
    $('#top-search').on('submit', function (e) {
        e.preventDefault();
        window.location =  vars.url.more+'?title='+$(this).find('input[name="title"]').val();
    });*/

    var maxImgSize = 1000000 * 4;
    var target;

    $(document).on('click','#add-images',function(e){
        e.preventDefault;
        $('#advertImages').trigger('click');
    });

    if (typeof Sortable === 'function')
    {
        var containerDrag = document.getElementById("sortable-photos");
        if (!!containerDrag) {
            var sortPhotos = Sortable.create(containerDrag, {
                animation: 150,
                draggable: '.draggable',
                dataIdAttr: 'data-att-id',
            });
            var advertImageList = sortPhotos.toArray();
            $.each(advertImageList, function (k, v) {
                advertImageList[k] = $('div[data-att-id="' + v + '"]').data('path');
            });
        }
    }

    $(document).on('change','#advertImages',function(e)
    {
        var fileList = this.files;
        console.log('test');
        var ind = 0;
        for (var i=0; i < fileList.length; i++) {
            if (fileList[i].type.match('image.*'))
            {
                console.log('2');
                if (fileList[i].size <= maxImgSize) {
                    if($('.img-thumb').length < 17)
                    {
                        console.log(fileList[i]);
                        ind = advertImageList.push(fileList[i]) - 1;
                        readAndPreview(fileList[i], $('div:not(.draggable) > .img-placeholder').first(), ind);
                        // console.log(advertImageList);
                        if (advertImageList.length > 5) {
                            $('.do-not-display').removeClass('do-not-display');
                            $('#payment_extra_photos.payment-js').prop('checked', true).change();
                            if(advertImageList.length == 6)
                            {
                                swal(vars.swal.more_images);
                            }
                        }
                    }
                    else swal(vars.swal.image_limit);
                } else {
                    swal(vars.swal.max_size);
                }
            }
            else swal(vars.swal.no_image);
        }


        function readAndPreview(file, preview, ind) {
            $(preview).parent().attr('data-att-id', ind).addClass('draggable');
            var reader = new FileReader();
            reader.addEventListener("load", function () {
                var div = $("<div/>", { class: 'img-thumb', style: 'background-image: url('+this.result+')' });
                $(preview).html(div).append('<i class="close">&times;</i>');
            }, false);
            if(file)
            {
                reader.readAsDataURL(file);
            }
        }
        $('#advertImages').val("");
    });

    $(document).on('click', '.img-placeholder .close', function (e) {
        e.preventDefault();
        var rmv = [];
        $.each($('.img-thumb').parent().parent(), function (k, v) {
            rmv[$(v).data('att-id')] = k;
        });
        var closest = $(this).closest('.img-placeholder').parent();
        var id = closest.data('att-id');
        var path = closest.data('path');
        if (typeof(advertImageList[rmv[id]].type) !== 'undefined' && advertImageList[rmv[id]].type.match('image.*'))
        {
            advertImageList.splice(rmv[id], 1);
        }
        else
        {
            $.post(vars.url.removeFiles, {path: closest.data('path')});
            advertImageList.splice(advertImageList.indexOf(closest.data('path')), 1);
        }
        closest.remove();
        $('#sortable-photos').append('<div class="col-xs-4 col-sm-3 col-md-3 col-lg-2 placeholder-wrapper do-not-display"><div class="img-placeholder">&nbsp;</div></div>');
        $('#sortable-photos').find('.do-not-display').first().removeClass('do-not-display');



        console.log(advertImageList);
        if (advertImageList.length < 6) {
            console.log($('.placeholder-wrapper').length);
            $('.placeholder-wrapper').slice(-12).addClass('do-not-display');
            $('#payment_extra_photos.payment-js').prop('checked', false).change();
        }

        // $('#sortable-photos > .draggable').each(function(index){
        //     $(this).data('att-id', index);
        //     console.log($(this));
        //     console.log(index+' '+ $(this).data('att-id'));
        // });

    });
    $('#add-advert').on('submit', function (e) {
        e.preventDefault();

        // var imgForm = new FormData();
        // // imgForm.append("id", msg['id']);
        // for(var i=0;i < advertImageList.length;i++){
        //     imgForm.append('images[' + (sortPhotos.toArray()[i]) + ']', advertImageList[i]);
        //     console.log(sortPhotos.toArray()[i]);
        //     console.log(advertImageList[i]);
        // }
        //
        // return;


        var route;
        var imgForm = new FormData();

        // for(var i=0;i < advertImageList.length;i++){
        //     imgForm.append('images[' + sortPhotos.toArray()[i] + ']', advertImageList[i]);
        // }
        // imgForm.append('order', sortPhotos.toArray());
        // $.ajax({
        //     url: vars.url.savefiles,
        //     type: 'POST',
        //     data: imgForm,
        //     cache: false,
        //     processData: false,
        //     contentType: false,
        //     success: function (data) {
        //         console.log(data);
        //     }
        // });
        // return;

        $.ajax({
            type: "POST",
            url: $(this).attr('action'),
            data: $(this).serialize(),
            beforeSend: function(){
                $('#spinner-modal').modal('show');
            },
            success: function (msg) {
                if ( msg.error ) {
                    var errorMsg = '';
                    $.each(msg.error, function (name, message) {
                        errorMsg +=  message + '<br>';
                        $('[name="' + name + '"]').addClass('has-error');
                    });
                    $('#spinner-modal').modal('hide');
                    swal({
                        title: vars.error,
                        type: 'error',
                        html: errorMsg
                    });
                    // $('#errordiv').html(errorMsg).show();
                    return;

                }
                route = msg;
                if(advertImageList) {
                    var imgForm = new FormData();
                    imgForm.append("id", msg['id']);
                    for(var i=0;i < advertImageList.length;i++){
                        imgForm.append('images[' +i + ']', advertImageList[i]);
                        console.log(sortPhotos.toArray()[i]);
                        console.log(advertImageList[i]);
                    }

                    imgForm.append('order', sortPhotos.toArray());

                    $.ajax({
                        url: vars.url.savefiles,
                        type: 'POST',
                        data: imgForm,
                        cache: false,
                        processData: false,
                        contentType: false,
                        success: function () {
                            route = msg;
                            if (route['error']) {
                                console.warn(route);
                            } else {
                                window.location.replace(route['route']);
                            }
                        },
                        error: function (e) {
                            console.log('cia1');
                            var errorMsg = '';
                            $.each(e, function (name, message) {
                                errorMsg +=  message + '<br>';
                                $('[name="' + name + '"]').addClass('has-error');
                            });

                            //$('#errordiv').show().find('div').html(errorMsg);
                            $('#spinner-modal').modal('hide');
                            swal({
                                title: vars.error,
                                type: 'error',
                                html: errorMsg
                            });
                        }
                    });

                } else
                    window.location.replace(route['route']);
            },
            error: function (data) {
                console.log('cia');
                var errorMsg = '';
                $.each(data.error, function (name, message) {
                    errorMsg += message + '<br>';
                    $('[name="' + name + '"]').addClass('has-error');
                });
                //$('#errordiv').show().html(errorMsg);
                $('#spinner-modal').modal('hide');
                swal({
                    title: vars.error,
                    type: 'error',
                    html: errorMsg
                });
            }
        });
    });

    $('#errordiv').html('');
    var payments = [];
    $(document).on('change', '.payment-js', function(){
            if(typeof $(this).data('price-id') !== 'undefined')
            {
                var price = 0.2;
                var select = $('select[data-price-id="'+$(this).data('price-id')+'"]');
                if(select.length > 1)
                {
                    $.each(select, function(index, el){
                        price *= $(el).val();
                    });
                }
                else
                {
                    price = 3 * select.val();
                }
                $('span[data-price-id="' + $(this).data('price-id') + '"]').html(price.toFixed(2));
            }
            var p_key = $(this).attr('name');
            var p_val = $(this).val();
            var index = payments.indexOf(p_key);
            if($(this).is(":checkbox:checked") || $(this).is("select"))
            {
                payments.push({name: p_key, value: parseInt(p_val)});
                if(p_val == "")
                {
                    payments.push({name: p_key, value: 0});
                }
            }
            else
            {
                payments = $.grep(payments, function(e){ return e.name !== p_key; });
            }
            updatePrice(payments);
    });
    function updatePrice(orders)
    {
        $.ajax({
            method: "POST",
            url: vars.url.getTotal,
            data: orders,
            success: function(response)
            {
                $("#price-pay").html(response);
                // console.log(Number(response) > 0);
                if(Number(response) > 0) {
                    $('#need_invoice').parent().show();
                } else {
                    $('#need_invoice').parent().hide();
                }
                // console.log('test1');
            }
        });
    }
    $(document).on('click', '#add-balance-button', function()
    {
        $('#add-balance-modal').modal('hide');
    });

    $('.update-services').click(function(){
        var id = $(this).data('id');
        $.ajax(
            {
                type: 'post',
                url: vars.url.getAdvertServices,
                data: { advert_id : id },
                dataType: 'html',
                success: function(response)
                {
                    $('#advert-services-quick').html(response);
                }
            }
        );
    });
    $('#search-type').change(function(){
        if($(this).val() != '0')
        {
            $('.js-input[name="type"]').val($(this).val()).removeAttr('disabled');
        }
        else
        {
            $('.js-input[name="type"]').attr('disabled', 'disabled');
        }
    });
    $('.sendfriend').on('submit',function(e) {
        e.preventDefault();
        var data = $('.sendfriend').serializeArray();
        data.push({name:'url',value:window.location.href});
        $.ajax({
            type: 'post',
            url: vars.url.sendtofriend,
            data: $.param(data),
            success: function (response) {
                console.log(response);
                $('#send-modal').modal('hide');
                swal(response['success']);

            }
        });
    });

    $('#inquiry-form').on('submit',function(e) {
        e.preventDefault();
        var data = $('#inquiry-form').serializeArray();
        $.ajax({
            type: 'post',
            url: vars.url.productInquiry,
            data: $.param(data),
            success: function (response) {
                $('#inquiry-modal').modal('hide');
                swal(response['success']);
            }
        });
    });

    $('#submit-search').click(function () {
        $('#top-search').submit();
    });

    // $('a[data-type]').click(function () {
    //     var typeId = $(this).data('type');
    //     $.ajax({
    //         type: 'POST',
    //         url: vars.url.getCategories,
    //         data: { type_id: typeId },
    //         success: function (response) {
    //             categories = response;
    //             var html = '<option value>'+vars.choose+'</option >';
    //             $.each(categories, function( index, value ) {
    //                 var selcted = '';
    //                 if(ctgs[0] == index.trim())
    //                 {
    //                     selcted = 'selected="selected"';
    //                 }
    //                 html += '<option value="'+index.trim()+'" '+selcted+'>'+value.name+'</option >';
    //             });
    //             $("select#category_id").html(html);
    //             $("select#category_id2").html(html);
    //             $("select#category_id2").trigger('change');
    //             $("select#category_id").trigger('change');
    //         }
    //     });
    //     $('#type').val(typeId);
    //     if ( typeId == 2) {
    //         $('.rent_prices').show();
    //         $('#price_input').closest('.col-sm-4').hide();
    //     } else {
    //         $('.rent_prices').hide();
    //         $('#price_input').closest('.col-sm-4').show();
    //
    //     }
    // });

    if ( $('span[data-type].active').data('type') == 2) {
        $('.rent_prices').show();

    }

    $('span[data-type]').click(function(){
        if ( $('#type').val() == 2) {
           var template =  $('#price_type_template').clone().removeClass('hidden');
            $('.price-type .seperator').append(template)
        } else {
            $('.price-type .seperator .template').remove();
        }
    });


    if($('input[name="type"]:checked').val() == 2)
    {
        $('.rent_prices').show();
        $('#price_input').hide();
    }
    $('.advancedSearch a').click(function(e){
        e.preventDefault();
        var data = [
            $('#category_id').val(),
            $('#subcategory_id').val(),
            $('#subsubcategory_id').val()
        ].join();
        window.location.href = $(this).attr('href')+'?categories='+data;
    });
    $(document).on('change', '#price_tba', function(){
        $(document).find('#price_input').val(0);
    });
    $(document).on('click', '[data-restore-id]', function(){
       $.ajax(
           {
               type: 'POST',
               url: vars.url.restoreAdvert,
               data: { advert_id: $(this).data('restore-id') },
               success: function (response) {
                   $('#restoreAdvert').html(response.success).css({ 'color' : 'green', 'font-weight' : 'bold'});
               }
           }
       ) ;
    });
    $('#login_lost_btn').on('click', function(){
        $('#lost-form').show();
        $('#login-form').hide();
    });
    $('#lost_login_btn').on('click', function(){
        $('#login-form').show();
        $('#lost-form').hide();
        console.log('from lost login');
    });



    $('#forgot-form').on('submit', function(event){
        console.log($(this).serialize());
        event.preventDefault();
        if($('#forgot-email').val().length < 6){
            $('#forgot-form ul').append('<li></li>');
        } else {
            $('#forgot-form li').each(function(){
                $(this).remove();
            });
            var route = [];
            $.ajax({
                type: "POST",
                data: $(this).serialize(),
                url: '/password/email',
                success: function (data) {
                    data = JSON.parse(data);
                    if(data.status) {
                        $('#login-modal').modal('hide');
                        swal(data.message);
                    } else {
                        $('#login-modal').modal('hide');
                        swal(data.message);
                    }
                },
                error: function (data) {
                    $('#login-modal').modal('hide');
                    swal(vars.toasts.password.not_found);
                }
            });
        }
    });

    // $(document).on('click', '.bookmark', function () {
    //     $(this).removeClass('bookmark').addClass('color-999');
    //     // setFav('favorites', $(this).data('id'), 30);
    //     Materialize.toast(vars.toasts.marked, 4000);
    // });



    $("#order-marked").on('change', function(){
        window.location.href = window.location.origin + window.location.pathname + '?order='+$(this).val();
    });

    $('#select_all').change(function () {
        $('.checkboxFav').prop('checked', this.checked);
        console.log($('.checkboxFav:checkbox:checked').length);
    });

    $('#delSelected').click(function () {
        console.log(vars.url.removeFav + ' '+$('.checkboxFav:checkbox:checked').length);
        if ($('.checkboxFav:checkbox:checked').length) {
            var delIDS = [];
            $('.checkboxFav:checkbox:checked').each(function (index, elem) {
                console.log($(elem).val());
                delIDS.push($(elem).val());
            });
            // window.location.reload();
            if(delIDS.length) {
                $.ajax({
                    type: "POST",
                    data: {'ids': delIDS},
                    url: vars.url.removeFav, //'/favorites/remove',
                    success: function (data) {
                        window.location.reload();
                    },
                    error: function (data) {
                        console.log(data);
                    }
                });
            }
        }

    });

    $('#need_invoice').change(function (){
        $('#need_invoive_fields').toggle();
    });

    $('#order-profile').on('change', function () {
        key = encodeURI('order'); value = encodeURI($(this).val());
        var kvp = document.location.search.substr(1).split('&');
        var i=kvp.length; var x; while(i--)
        {
            x = kvp[i].split('=');
            if (x[0]==key)
            {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }
        if(i<0) {kvp[kvp.length] = [key,value].join('=');}
        document.location.search = kvp.join('&');
    });

    $('#filter-profile').on('change', function () {
        key = encodeURI('mainCat');
        value = encodeURI($(this).val());
        var kvp = document.location.search.substr(1).split('&');
        var i=kvp.length; var x; while(i--)
        {
            x = kvp[i].split('=');
            if (x[0]==key)
            {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }
        if(i<0) {kvp[kvp.length] = [key,value].join('=');}
        document.location.search = kvp.join('&');
    });

    $(document).on('click', '.advert__results--more', function () {
        var x = $(this);
        var par = $(this).parent();
        $(par).find('.advert__results--hidden').toggle('fast', function () {
            if($(par).find('.advert__results--hidden:hidden').length > 0){
                $(x).text(vars.watch_more);
            } else {
                $(x).text(vars.watch_less);
            }
        });
    });

    $(document).on('click', '#advanced', function (e) {
        e.preventDefault();
        var values = $('#indexSearch').serialize();
        var params = URI.parseQuery('?'+values);

        if(params['make_id'] == '0') {
            delete params['make_id'];
        }
        if(params['country_id'] == 0 || params['country_id'] == '0')
            delete params['country_id'];
        //console.log(params);
        $.each(params, function(key, value) {
            // console.log(key+' '+value);

            if(value == "" || value == "0")
            {
                delete params[key];
            } else {
                if($.isArray(value)) {
                    if($.isEmptyObject(value)) {
                        delete params[key];
                    } else if((value[0] == "0" || value[0] == "") && (value[1] == "0" || value[1] == "") ){
                        delete params[key];
                    }
                    else {
                        if(value[0] != "" || value[1] != "") {
                            if(value[0] == "")
                                value[0] = 0;
                            if(value[1] == "")
                                value[1] = 0;
                            params[key.replace('[]', '')] = value[0] + ',' + value[1];
                        }
                        delete params[key];
                    }
                }
            }
        });
        var uri = new URI($(this).attr('href'));
        uri.setSearch(params);
        window.location = uri.href();
    });

    $('input[name="radio"]').on('change', function () {
        var val = $(this).val();
        console.log(val);
        $price = $('input[name="price"]').first();
        if(val == 'f_746261'){
            $price.prop('disabled', true);
            $price.val('0.00');
            console.log($price);
        } else{
            $price.prop('disabled', false);
            console.log('price enabled');
        }
    });
});
